module.exports = __webpack_public_path__ + "img/da6fd649ebedc9afb8a0952a30849898.6a107e37.png";